import { useTranslation } from "next-i18next";

const MARKETPLACE_V3_NAMESPACES = [
    "marketplaceV3",
    "homepageV2",
    "mktCardV2",
    "load-form",
    "navigation",
    "common"
] as const;

const useMarketplaceV3Translation = () => useTranslation(MARKETPLACE_V3_NAMESPACES);

export default useMarketplaceV3Translation;
